export var JabberCustomTypeData;
(function (JabberCustomTypeData) {
    JabberCustomTypeData["AI_ASSISTANT_BLOCKED"] = "AI_ASSISTANT_BLOCKED";
    JabberCustomTypeData["ROOM_LOCKED"] = "ROOM_LOCKED";
    JabberCustomTypeData["AUTH_TOKEN"] = "AUTH_TOKEN";
    JabberCustomTypeData["ROOM_CREATE"] = "ROOM_CREATE";
    JabberCustomTypeData["LEAVE_ROOM"] = "LEAVE_ROOM";
})(JabberCustomTypeData || (JabberCustomTypeData = {}));
//# sourceMappingURL=jabber-custom-type-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/jabber-dto/jabber-custom-type-data.js
// module id = 536
// module chunks = 14